import React from 'react';
import { Box, Typography, Paper, Chip, Divider } from '@mui/material';
import { Security, Timeline, Person } from '@mui/icons-material';

interface RiskCardProps {
  riskData: any;
  onViewHistory: () => void;
}

const RiskCard: React.FC<RiskCardProps> = ({ riskData, onViewHistory }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Aprobado':
        return 'success';
      case 'Rechazado':
        return 'error';
      default:
        return 'warning';
    }
  };

  return (
    <Paper
      onClick={onViewHistory}
      sx={{
        p: 2,
        mb: 2,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#fafafa',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '40%' }}>
        <Box
          sx={{
            backgroundColor: 'rgba(25, 118, 210, 0.12)',
            borderRadius: '50%',
            p: 0.75,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Security sx={{ fontSize: '1rem', color: 'primary.main' }} />
        </Box>
        <Box>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 700,
              lineHeight: 1,
              fontSize: { xs: '0.95rem', md: '1.05rem' },
              whiteSpace: 'nowrap',
            }}
          >
            {riskData.identifier}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              lineHeight: 1,
              whiteSpace: 'nowrap',
              mt: 0.2,
            }}
          >
            Evaluación de Riesgo
          </Typography>
        </Box>
      </Box>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <Chip
        label={riskData.evaluation}
        color={getStatusColor(riskData.evaluation) as any}
        size="small"
        sx={{ height: 20, fontSize: '0.7rem', fontWeight: 600 }}
      />

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            backgroundColor: 'rgba(255, 152, 0, 0.05)',
            p: 0.75,
            borderRadius: '50%',
            mr: 1,
          }}
        >
          <Timeline sx={{ fontSize: '0.95rem', color: 'warning.main' }} />
        </Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, fontSize: '0.8rem', lineHeight: 1 }}
        >
          {riskData.evaluations?.length || 0}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: '0.65rem', ml: 0.5 }}
        >
          Evaluaciones
        </Typography>
      </Box>

      {riskData.evaluations?.length > 0 && (
        <>
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              minWidth: 120,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                backgroundColor: 'rgba(128, 128, 128, 0.05)',
                p: 0.75,
                borderRadius: '50%',
                mr: 1,
              }}
            >
              <Person sx={{ fontSize: '0.95rem', color: 'text.secondary' }} />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, fontSize: '0.8rem', lineHeight: 1 }}
            >
              {riskData.evaluations[0]?.reviewerName || 'N/A'}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: '0.65rem', ml: 0.5 }}
            >
              Último evaluador
            </Typography>
          </Box>
        </>
      )}
    </Paper>
  );
};

export default RiskCard;
